<template>
  <div id="navimg" class="navimg">
    <img :src="path" alt="nav1" />
  </div>
</template>

<script>
  export default {
    name: "Navimg",
    data() {
      return {
      };
    },
    props: {
      path:String
    },
  };
</script>

<style scoped>
  .navimg{
    width: 100%;
  }
  .navimg img{
    width: 100%;
    height: 100%;
   object-fit: contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navimg.vue